import { useQuery, UseQueryResult } from 'react-query';
import { SalesPortalKiloClassRetrieve } from 'types';
import { client } from 'utils/api-client';

type UseSalesPortalKiloClassProps = {
  gymId: string | undefined;
  kiloClassId: string | undefined;
  /** The sub-account the purchase is for; the server honors it only when the requester owns it. */
  profileId?: string;
  /** Part of the query key so signing in refetches the relationship the server resolves. */
  sessionUserId?: string;
  enabled?: boolean;
};

function useSalesPortalKiloClass({
  gymId,
  kiloClassId,
  profileId,
  sessionUserId,
  enabled = true,
}: UseSalesPortalKiloClassProps): UseQueryResult<{ data: SalesPortalKiloClassRetrieve }> {
  const params = new URLSearchParams();
  if (profileId) {
    params.append('profile_id', profileId);
  }
  const query = params.toString();

  return useQuery(
    ['salesPortalKiloClass', gymId, kiloClassId, profileId ?? null, sessionUserId ?? null],
    () =>
      client.get<SalesPortalKiloClassRetrieve>(
        `sales-portal/gyms/${gymId}/kilo-classes/${kiloClassId}/${query ? `?${query}` : ''}`,
      ),
    {
      enabled: enabled && !!gymId && !!kiloClassId,
    },
  );
}

export default useSalesPortalKiloClass;
